<app-standard-bottom-sheet [isOpen]="isOpen()"
                          [isFullScreen]="true"
                          [preventOverlayClose]="hasUnsavedChanges"
                          (isOpenChange)="onSheetOpenChange($event)"
                          (overlayClick)="onDismissRequested()"
                          testId="checklist-looks-good-sheet">

  <app-section-header title="Edit"
                      align="center"
                      testId="checklist-looks-good-sheet" />

  <form [formGroup]="form"
        class="checklist-looks-good-form"
        data-testid="checklist-looks-good-sheet-form">
    <p class="assertion-text"
       [innerHTML]="assertionText()"
       data-testid="checklist-looks-good-sheet-text-assertion"></p>

    <app-form-field label="Add Photos"
                    [optional]="true"
                    [labelSuffix]="'(Max ' + maxPhotos + ')'"
                    testId="checklist-looks-good-sheet-photos">
      <app-photo-capture inputId="checklist-looks-good-sheet"
                         [images]="photoThumbnails()"
                         [disabled]="imageCompressionPipelineService.isCompressingImages()"
                         [loading]="imageCompressionPipelineService.isLoadingImages()"
                         [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                         [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                         (filesSelected)="onPhotosSelected($event)"
                         (imageClicked)="openImagesModal($event)"
                         testId="checklist-looks-good-sheet-photo" />
    </app-form-field>

    <app-form-field label="Notes"
                    inputId="checklist-looks-good-notes"
                    [optional]="true"
                    [control]="form.controls.notes"
                    [maxLength]="maxNoteLength"
                    testId="checklist-looks-good-sheet-notes">
      <app-textarea inputId="checklist-looks-good-notes"
                    formControlName="notes"
                    placeholder="Add a note about this item..."
                    [maxLength]="maxNoteLength"
                    [showCount]="false"
                    testId="checklist-looks-good-sheet-textarea-notes" />
    </app-form-field>
  </form>

  <app-vertical-button-group [buttons]="footerButtons"
                             testId="checklist-looks-good-sheet-footer" />
</app-standard-bottom-sheet>
